// /* eslint-disable */

// import { HiX } from "react-icons/hi";
// import Links from "./components/Links";

// import SidebarCard from "components/sidebar/componentsrtl/SidebarCard";
// import routes from "routes.js";

// const Sidebar = ({ open, onClose }) => {
//   return (
//     <div
//       className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
//         open ? "t ranslate-x-0" : "-translate-x-96"
//       }`}
//     >
//       <span
//         className="absolute top-4 right-4 block cursor-pointer xl:hidden"
//         onClick={onClose}
//       >
//         <HiX />
//       </span>

//       <div className={`mx-[56px] mt-[50px] flex items-center`}>
//         <div className="mt-1 ml-1 h-2.5 font-poppins text-[26px] font-bold uppercase text-navy-700 dark:text-white">
//           EMS <span class="font-medium"></span>
//         </div>
//       </div>
//       <div class="mt-[58px] mb-7 h-px bg-gray-300 dark:bg-white/30" />

//       <ul className="mb-auto pt-1">
//         <Links routes={routes} />
//       </ul>

//       {/* <div className="flex justify-center">
//         <SidebarCard />
//       </div> */}

//     </div>
//   );
// };

// export default Sidebar;

// import React from "react";
// import { HiX, HiMenuAlt2, HiBell, HiSun } from "react-icons/hi";
// import { FiChevronDown } from "react-icons/fi";
// import SidebarLinks from "./components/Links";
// import routes from "routes.js";

// const Sidebar = ({ open, onClose, collapsed, onToggleCollapse }) => {
//   return (
//     <div
//       className={`duration-300 fixed !z-50 flex h-[calc(100vh-2rem)] flex-col justify-between rounded-3xl bg-[#f8f9fa] p-3 shadow-sm transition-all dark:bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
//         open ? "translate-x-0" : "-translate-x-96 xl:translate-x-0"
//       } ${collapsed ? "w-20" : "w-72"} `}
//     >
//       {/* --- TOP SECTION --- */}
//       <div className="flex flex-col gap-6 shrink-0">
//         {/* Header: Logo & Toggle Icon */}
//         <div
//           className={`flex items-center pt-2 ${
//             collapsed ? "justify-center" : "justify-between px-2"
//           }`}
//         >
//           {!collapsed && (
//             <h1 className="text-xl font-bold tracking-tight text-gray-900 dark:text-white whitespace-nowrap">
//               Logo Here
//             </h1>
//           )}

//           {/* Toggle Button for Mobile and Desktop Mini View */}
//           <button
//             onClick={() => {
//               // On mobile screens, close the overlay sidebar; on desktop screens, toggle mini/expanded
//               if (window.innerWidth < 1200) {
//                 onClose();
//               } else {
//                 onToggleCollapse();
//               }
//             }}
//             className="text-gray-500 hover:text-gray-700 dark:text-gray-300 p-1.5 rounded-lg hover:bg-gray-200/50"
//             title={collapsed ? "Expand Sidebar" : "Collapse Sidebar"}
//           >
//             <HiX className="h-6 w-6 xl:hidden" />
//             <HiMenuAlt2 className="hidden h-6 w-6 xl:block" />
//           </button>
//         </div>

//         {/* Profile / Admin Card */}
//         <div
//           className={`flex items-center ${
//             collapsed ? "justify-center" : "justify-between px-2"
//           }`}
//         >
//           <div className="flex items-center gap-2.5">
//             {/* Avatar Circle */}
//             <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#111827] text-sm font-bold text-white shadow-sm">
//               A
//             </div>
//             {!collapsed && (
//               <div className="flex items-center gap-1 cursor-pointer whitespace-nowrap">
//                 <span className="text-sm font-semibold text-gray-800 dark:text-white">
//                   Admin
//                 </span>
//                 <FiChevronDown className="h-4 w-4 text-gray-500" />
//               </div>
//             )}
//           </div>

//           {!collapsed && (
//             <div className="relative cursor-pointer p-1.5 text-gray-700 hover:text-gray-900 dark:text-white">
//               <HiBell className="h-5 w-5" />
//               <span className="absolute top-0 right-0 flex h-4 w-4 items-center justify-center rounded-full bg-red-600 text-[10px] font-bold text-white">
//                 3
//               </span>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* --- MIDDLE SECTION: Menu Items --- */}
//       <div className="my-4 flex-1 overflow-y-auto pr-0 custom-scrollbar [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
//         <ul className="flex flex-col gap-1.5 pt-2">
//           <SidebarLinks routes={routes} collapsed={collapsed} />
//         </ul>
//       </div>

//       {/* --- BOTTOM SECTION: Mode Toggle --- */}
//       <div
//         className={`flex items-center pt-3 border-t border-gray-200/60 dark:border-white/10 shrink-0 ${
//           collapsed ? "justify-center" : "justify-between px-2"
//         }`}
//       >
//         {!collapsed && (
//           <span className="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">
//             Light Mode
//           </span>
//         )}
//         <button className="rounded-lg p-1.5 text-gray-500 hover:bg-gray-200/60 dark:text-gray-300">
//           <HiSun className="h-5 w-5" />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

import React, { useState, useEffect, useMemo } from "react";
import { HiX, HiMenuAlt2 } from "react-icons/hi";
import { FiChevronDown, FiUser, FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import SidebarLinks from "./components/Links";
import routes from "routes.js";
import Dropdown from "components/dropdown";
import { useOrganizers } from "components/company/hooks/useOrganizers";
import { useMasterCompany } from "components/masterCompanies/hooks/userMasterCompany";
import { setAccessToken } from "api/axios";

const Sidebar = ({ open, onClose, collapsed, onToggleCollapse }) => {
  const navigate = useNavigate();
  const { companies, loading: loadingCompanies } = useOrganizers();
  const { masterCompanies, loading: loadingMaster } = useMasterCompany();

  const [selectedMasterCompany, setSelectedMasterCompany] = useState(
    localStorage.getItem("master_company_id") || ""
  );
  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );
  const [role, setRole] = useState("staff");
  const [userData, setUserData] = useState(null);

  // Sync User Data & Role
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("userData"));
    if (data) {
      setUserData(data);
      setRole(data.role || "staff");
    }
  }, []);

  // Filter companies based on selected Master Company
  const filteredCompanies = useMemo(() => {
    if (!companies || companies.length === 0) return [];
    if (!selectedMasterCompany) return companies;
    return companies.filter((c) => c.masterCompanyId === selectedMasterCompany);
  }, [companies, selectedMasterCompany]);

  // Sync Master Company
  useEffect(() => {
    if (!loadingMaster && masterCompanies.length > 0) {
      const storedCompanyId = localStorage.getItem("company_id");
      const storedMasterId = localStorage.getItem("master_company_id");

      if (storedCompanyId && companies.length > 0) {
        const matchingCompany = companies.find(
          (c) => c._id === storedCompanyId
        );
        if (matchingCompany && matchingCompany.masterCompanyId) {
          setSelectedMasterCompany(matchingCompany.masterCompanyId);
          localStorage.setItem(
            "master_company_id",
            matchingCompany.masterCompanyId
          );
          return;
        }
      }

      const exists = masterCompanies.some((mc) => mc._id === storedMasterId);
      if (!storedMasterId || !exists) {
        const defaultMaster = masterCompanies[0]._id;
        setSelectedMasterCompany(defaultMaster);
        localStorage.setItem("master_company_id", defaultMaster);
      }
    }
  }, [masterCompanies, loadingMaster, companies]);

  // Sync Selected Organizer
  useEffect(() => {
    if (
      !loadingCompanies &&
      filteredCompanies.length > 0 &&
      selectedMasterCompany
    ) {
      const storedCompanyId = localStorage.getItem("company_id");
      const existsInFiltered = filteredCompanies.some(
        (c) => c._id === storedCompanyId
      );

      if (!storedCompanyId || !existsInFiltered) {
        const defaultCompany = filteredCompanies[0]._id;
        setSelectedOrganizer(defaultCompany);
        localStorage.setItem("company_id", defaultCompany);
      }
    }
  }, [filteredCompanies, loadingCompanies, selectedMasterCompany]);

  // Dispatch Organizer Change Event
  useEffect(() => {
    if (selectedOrganizer) {
      localStorage.setItem("company_id", selectedOrganizer);
      const company = companies.find((c) => c._id === selectedOrganizer);
      if (company && company.primaryColor) {
        document.documentElement.style.setProperty(
          "--color-primary",
          company.primaryColor
        );
      }
      window.dispatchEvent(
        new CustomEvent("companyChanged", { detail: selectedOrganizer })
      );
    }
  }, [selectedOrganizer, companies]);

  const handleMasterChange = (masterId) => {
    setSelectedMasterCompany(masterId);
    localStorage.setItem("master_company_id", masterId);
    window.dispatchEvent(
      new CustomEvent("masterCompanyChanged", { detail: masterId })
    );
  };

  // --- LOG OUT HANDLER ---
  const handleLogout = (e) => {
    e.preventDefault();

    // 1. Clear access token from axios memory helper if used
    if (typeof setAccessToken === "function") {
      setAccessToken(null);
    }

    // 2. Clear all cached keys in local storage
    localStorage.clear();

    // 3. Redirect to login page
    navigate("/auth/sign-in", { replace: true });
  };

  const isMasterCompanyAccess = role === "admin";
  const isOrganizerAccess = role === "admin" || role === "masterCompany";

  const currentOrganizerName =
    companies.find((c) => c._id === selectedOrganizer)?.companyName ||
    "HORECA SUMMIT";

  return (
    <div
      className={`fixed !z-50 flex h-screen flex-col justify-between border-r border-gray-200 bg-[#f8fafc] p-4 transition-all duration-300 dark:border-white/10 dark:bg-navy-800 xl:translate-x-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      } ${collapsed ? "w-20" : "w-64"}`}
    >
      {/* Top Header & Selector Container */}
      <div className="flex flex-col gap-5">
        <div className="flex items-center justify-between px-1 pt-2">
          {!collapsed && (
            <div className="flex items-center gap-2">
              <img
                src="/loginlogo.png"
                alt="HORECA Insight"
                className="h-[60px] rounded-lg object-contain"
              />
              <span className="text-[20px] font-extrabold tracking-tight text-gray-900 dark:text-white">
                HORECA
                <br />
                INSIGHT
              </span>
            </div>
          )}

          <button
            onClick={() => {
              if (window.innerWidth < 1200) {
                onClose();
              } else {
                onToggleCollapse();
              }
            }}
            className="rounded-lg p-1 text-gray-500 hover:bg-gray-200/50 dark:text-gray-300"
          >
            <HiX className="h-6 w-6 xl:hidden" />
            <HiMenuAlt2 className="hidden h-6 w-6 xl:block" />
          </button>
        </div>

        {/* Dynamic Organizer / Master Selector Card */}
        {/* {!collapsed && (
          <Dropdown
            button={
              <button
                disabled={!isOrganizerAccess && !isMasterCompanyAccess}
                className="flex w-full items-center justify-between rounded-xl border border-gray-200/80 bg-white p-2.5 shadow-sm transition-all hover:border-gray-300 dark:border-white/10 dark:bg-navy-700"
              >
                <div className="flex items-center gap-2.5 overflow-hidden">
                  <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-black text-xs font-bold text-white">
                    S
                  </div>
                  <span className="truncate text-xs font-bold tracking-tight text-gray-800 dark:text-white">
                    {currentOrganizerName}
                  </span>
                </div>
                <FiChevronDown className="h-4 w-4 shrink-0 text-gray-400" />
              </button>
            }
            children={
              <div className="flex w-56 flex-col rounded-xl border border-gray-100 bg-white p-2 shadow-xl dark:border-white/10 dark:bg-navy-700">

                {isMasterCompanyAccess && (
                  <div className="mb-2 border-b border-gray-100 pb-2 dark:border-white/10">
                    <p className="px-2 pb-1 text-[10px] font-bold uppercase text-gray-400">
                      Master Company
                    </p>
                    {masterCompanies.map((mc) => (
                      <button
                        key={mc._id}
                        onClick={() => handleMasterChange(mc._id)}
                        className={`w-full rounded-lg px-2 py-1.5 text-left text-xs ${
                          selectedMasterCompany === mc._id
                            ? "bg-indigo-50 font-bold text-indigo-900 dark:bg-white/10 dark:text-indigo-400"
                            : "text-gray-700 hover:bg-gray-50 dark:text-gray-200"
                        }`}
                      >
                        {mc.masterCompanyName}
                      </button>
                    ))}
                  </div>
                )}

                <div>
                  <p className="px-2 pb-1 text-[10px] font-bold uppercase text-gray-400">
                    Organizers
                  </p>
                  {filteredCompanies.map((company) => (
                    <button
                      key={company._id}
                      onClick={() => setSelectedOrganizer(company._id)}
                      className={`w-full rounded-lg px-2 py-1.5 text-left text-xs ${
                        selectedOrganizer === company._id
                          ? "bg-amber-50 font-bold text-amber-900 dark:bg-white/10 dark:text-amber-400"
                          : "text-gray-700 hover:bg-gray-50 dark:text-gray-200"
                      }`}
                    >
                      {company.companyName}
                    </button>
                  ))}
                </div>
              </div>
            }
            classNames="top-12 left-0 w-full z-50"
          />
        )} */}
      </div>

      {/* Navigation Links Area */}
      <div className="my-3 flex-1 overflow-y-auto pr-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <ul className="flex flex-col gap-1">
          <SidebarLinks routes={routes} collapsed={collapsed} />
        </ul>
      </div>

      {/* User Profile Card Footer */}
      {!collapsed && (
        <Dropdown
          className="bottom-14 left-0 z-50 w-full"
          button={
            <button className="flex w-full items-center gap-3 rounded-[8px] border-t bg-[#ffffff] p-[8px] text-left transition-colors hover:bg-gray-50 dark:bg-navy-700 dark:hover:bg-navy-600">
              <div className="border-black bg-black flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 p-[3px] text-xs font-bold">
                <img
                  src="/userAvather.png"
                  alt="Profile"
                  className="h-[80%] w-full rounded-full object-cover"
                />
              </div>

              <div className="flex flex-col overflow-hidden">
                <span className="truncate text-xs font-bold text-gray-800 dark:text-white capitalize">
                  {"Admin"}
                </span>
                <span className="truncate text-[11px] text-gray-400">
                  {userData?.email || "admin@gmail.com"}
                </span>
              </div>
            </button>
          }
          children={
            <div className="flex w-52 flex-col rounded-xl border border-gray-100 bg-white p-2 shadow-lg dark:border-white/10 dark:bg-navy-700">
              <div className="border-b border-gray-100 p-2 dark:border-white/10">
                <p className="truncate text-xs font-bold text-gray-800 dark:text-white">
                  {"Admin"}
                </p>
                <p className="truncate text-[11px] text-gray-400">
                  {userData?.email || "admin@gmail.com"}
                </p>
              </div>

              <div className="flex flex-col gap-1 p-1 pt-2 text-xs">
                {/* <button
                  onClick={() => navigate("/admin/profile")}
                  className="flex items-center gap-2 rounded-lg px-2.5 py-1.5 text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-white/10"
                >
                  <FiUser className="h-4 w-4" />
                  Profile
                </button> */}
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-2 rounded-lg px-2.5 py-1.5 font-medium text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10"
                >
                  <FiLogOut className="h-4 w-4" />
                  Log Out
                </button>
              </div>
            </div>
          }
          classNames={"py-2 bottom-14 left-0 w-max z-50"}
        />
      )}
    </div>
  );
};

export default Sidebar;
